/* eslint-disable no-undef */
import React, { Fragment, useState, useEffect } from "react";
import SimpleReactValidator from "simple-react-validator";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import {
  checkLoggedIn,
  getDeliveryCharges,
  mergeClasses,
  totalCartPrice,
} from "../../utils";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import CustomPhoneInput from "../Input/CustomPhoneInput";
import AddressCard from "../Cards/AddressCard";
import axios from "axios";
import { PulseLoader } from "react-spinners";
import {
  GetCountries,
  GetState,
  GetCity,
} from "react-country-state-city";
import ReactSelect from "../UI/Select/ReactSelect";
import AddressesSection from "../AddressesSection";
import _ from "lodash";
import { useSelector } from "react-redux";
import { fCurrency } from "../../utils/formatNumber";
import { useCart } from "../../Context/CartContext";
import PrescriptionUpload from "./PrescriptionUpload";
import "./index.css";

const CheckoutSection = ({ cartList, updateConfigs, token, configs, ...props }) => {

  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("checkDeposit");
  const [iframeUrl, setIframeUrl] = useState(null);
  const [heardAboutUs, setHeardAboutUs] = useState("");
  const [otherReferralDetails, setOtherReferralDetails] = useState("");

  const push = useNavigate();
  const [tabs, setExpanded] = useState({ cupon: false });
  const { cart } = useCart();
  const delivery_charges = useSelector((state) => state?.configs?.admin_conditions?.delivery_charges);
  const loggedInCartPrice = useSelector((state) => state?.cartList?.totalPrice);
  const totalPrice = checkLoggedIn()
    ? loggedInCartPrice || 0
    : (carts?.length > 0 ? totalCartPrice(carts) : 0) + delivery_charges || 0;

  const [placeOrderLoading, setPlaceOrderLoading] = useState("");
  const [prescriptionFile, setPrescriptionFile] = useState(null);

  const handlePrescriptionUpload = (file) => {
    setPrescriptionFile(file);
    toast.success("Prescription uploaded successfully!");
  };

  const allowedDomain = "premiumpymts.com";
  const handleIframeLoad = (e) => {
    try {
      const currentUrl = e.target.contentWindow.location.href;
      const currentDomain = new URL(currentUrl).hostname;
      if (currentDomain !== allowedDomain && !currentDomain.endsWith(`.${allowedDomain}`)) {
        window.open(currentUrl, "_blank");
        window.close();
      }
    } catch (err) {
      console.error("Error checking iframe URL:", err);
    }
  };

  const handleCreateOrder = async () => {
    if (_?.isEmpty(configs?.selectedAddress)) {
      toast.error("Select Address");
      return;
    }

    setPlaceOrderLoading(true);

    if (selectedPaymentMethod === "visaMastercard") {
      await axios.post(
        "create-order",
        { addressid: configs?.selectedAddress?._id },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      ).then((res) => {
        if (res?.data?.status === "ok") {
          handlePayment(res?.data);
        } else {
          toast.error("error here", res?.data?.message);
        }
        setPlaceOrderLoading(false);
      }).catch((err) => {
        console.error("Error creating order:", err);
        setPlaceOrderLoading(false);
      });
    } else {
      await axios.post(
        "create-order-check",
        { addressid: configs?.selectedAddress?._id },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      ).then((res) => {
        if (res?.data?.status === "ok") {
          setIframeUrl(res.data.payment_url);
        } else {
          toast.error(res?.data?.message);
        }
        setPlaceOrderLoading(false);
      }).catch((err) => {
        setPlaceOrderLoading(false);
      });
    }
  };

  function handlePayment(data) {
    try {
      if (typeof Epay !== "undefined") {
        const options = {
          channelId: "WEB",
          customerId: data?.userid,
          merchantType: "ECOMMERCE",
          merchantId: "6363397438889",
          orderID: data?.order,
          orderDescription: "Purchasing Product",
          orderAmount: data?.totalPrice,
          orderCurrency: "USD",
          email: data?.email,
          name: data?.email,
          successHandler: async function (response) {
            push(`/success/${data?.order}`);
          },
          failedHandler: async function (response) {
            push(`/failed/${data?.order}`);
          },
        };

        const neo = new Epay(options);
        neo.open(options);
      }
    } catch (err) {
      console.error("Payment error:", err);
      toast.error("Payment processing failed. Please try again.");
    }
  }

  const handlePaymentChange = (event) => {
    setSelectedPaymentMethod(event.target.value);
  };

  return (
    <Fragment>
      <div className="checkout-area sm-separator-padding">
        {!iframeUrl && (
          <div className="sm-container">
            <div className="checkout-wrap">
              <div className="row">
                <div className="col-lg-6 col-12">
                  <AddressesSection />

                  {/* Prescription Upload */}
                  <div className="mb-6 mt-4">
                    <h3 className="mb-3">Add Your Prescription</h3>
                    <div className="w-100" style={{ maxWidth: "100%" }}>
                      <PrescriptionUpload onUpload={handlePrescriptionUpload} />
                      {prescriptionFile && (
                        <p className="mt-2 text-sm text-green-600 text-break">File selected: {prescriptionFile.name}</p>
                      )}
                    </div>
                  </div>

                  {/* How Did You Hear About Us */}
                  <div className="mt-4">
  <h3 className="mb-3">How Did You Hear About Us?</h3>
  <div className="custom-select-wrapper mb-10">
    <select
      className="form-control select-container"
      value={heardAboutUs}
      onChange={(e) => {
        setHeardAboutUs(e.target.value);
        updateConfigs({ heardAboutUs: e.target.value });
        if (e.target.value !== "Other (Please Specify)") {
          setOtherReferralDetails("");
          updateConfigs({ otherReferralDetails: "" });
        }
      }}
    >
      <option value="" disabled>Select an option</option>
      <option>Social Media (Facebook, Instagram, Twitter, etc.)</option>
      <option>Google Search</option>
      <option>YouTube</option>
      <option>Online Advertisement</option>
      <option>Telegram</option>
      <option>WhatsApp</option>
      <option>Referral from a Friend</option>
      <option>IB/Partner Referral</option>
      <option>Forex Forum or Blog</option>
      <option>Email Newsletter</option>
      <option>Webinar or Online Event</option>
      <option>Influencer/Content Creator</option>
      <option>App Store / Play Store</option>
      <option>Existing Client</option>
      <option>Other (Please Specify)</option>
    </select>
    <span className="custom-dropdown-icon">&#9662;</span>
  </div>

  {heardAboutUs === "Other (Please Specify)" && (
    <input
      type="text"
      className="form-control mt-3"
      placeholder="Please specify"
      value={otherReferralDetails}
      onChange={(e) => {
        setOtherReferralDetails(e.target.value);
        updateConfigs({ otherReferralDetails: e.target.value });
      }}
    />
  )}
</div>

                </div>

                <div className="col-lg-6 col-12">
                  <div className="checkout-order-area">
                    <h3>Your Order</h3>
                    <div className="oreder-item">
                      <div className="title bg-title">
                        <h2>
                          Products <span>Subtotal</span>
                        </h2>
                      </div>
                      {cartList?.map((item) => (
                        <div className="oreder-product" key={item.id}>
                          <div className="images">
                            <span className="mr-10">
                              <img src={item?.proimg?.[0]?.src} alt="" />
                            </span>
                            <small>
                              {item.title} ${fCurrency(item.price)} x {item.qty}
                            </small>
                          </div>
                          <span> ${fCurrency(item.qty * item.price)}</span>
                        </div>
                      ))}

                      <div className="title s1">
                        <h2>
                          Delivery Charge<span>${getDeliveryCharges()}</span>
                        </h2>
                      </div>
                      <div className="title s1">
                        <h2>
                          Subtotal
                          <span>${fCurrency(totalPrice - Number(configs?.admin_conditions?.delivery_charges))}</span>
                        </h2>
                      </div>
                      <div className="title s2">
                        <h2>
                          Total
                          <span>${fCurrency(totalPrice)}</span>
                        </h2>
                      </div>
                    </div>

                    {/* Payment Method */}
                    <div className="payment-option">
                      <h3>Payment Method</h3>
                      <div className="payment-select">
                        <ul>
                          <li className="removeToggle">
                            <input
                              id="remove"
                              type="radio"
                              name="payment"
                              checked={selectedPaymentMethod === "checkDeposit"}
                              onChange={handlePaymentChange}
                              value="checkDeposit"
                            />
                            <label htmlFor="remove">Check payments</label>
                          </li>

                          <li className="addToggle">
                            <input
                              id="add"
                              type="radio"
                              name="payment"
                              checked={selectedPaymentMethod === "visaMastercard"}
                              onChange={handlePaymentChange}
                              value="visaMastercard"
                            />
                            <label htmlFor="add">Visa/Mastercard Credit Card</label>
                          </li>
                        </ul>
                      </div>

                      <div className="payment-bottom">
                        <p>
                          Your personal data will be used to process your order, support your experience throughout this website, and for other purposes described in our privacy policy.
                        </p>

                        <div className="payment-btn">
                          <button
                            className="btn-style-1"
                            style={{ width: "100%" }}
                            onClick={handleCreateOrder}
                            disabled={placeOrderLoading || cart?.loading}
                          >
                            {placeOrderLoading || cart?.loading ? <PulseLoader size={10} color={"#fafafa"} /> : "Place order"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {iframeUrl && (
          <div className="m-auto w-10/12">
            <h3 className="text-lg font-medium text-gray-800 mb-2">Check Deposit</h3>
            <iframe
              src={iframeUrl}
              title="Check Deposit"
              className="w-full"
              style={{ height: "900px", border: "1px solid #ccc", borderRadius: "8px" }}
              onLoad={handleIframeLoad}
            />
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default CheckoutSection;